import { ui } from '@/components/ui';
import s from './Mfa.module.css';

// One box for both a 6-digit app code and a recovery code like "k7mq-p3xz".
export function CodeInput({
  id,
  value,
  onChange,
  autoFocus,
}: {
  id: string;
  value: string;
  onChange: (v: string) => void;
  autoFocus?: boolean;
}) {
  return (
    <input
      id={id}
      className={`${ui.input} ${s.codeInput}`}
      value={value}
      onChange={(e) => {
        onChange(e.target.value);
      }}
      inputMode="text"
      autoComplete="one-time-code"
      autoCapitalize="none"
      spellCheck={false}
      maxLength={12}
      placeholder="123456"
      required
      autoFocus={autoFocus}
    />
  );
}
